module.exports = __webpack_public_path__ + "img/bird05.131e64bc.png";